import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function isPreparerAssignmentExistReducer(
	state = initialState.userAssignementInformation,
	action
) {
	switch (action.type) {
		case types.CREATE_TASK_ASSIGNMENT: {
			return {
				...initialState.userAssignementInformation,
				isPreparerAssignmentExist: action.response
			}

		}
		case types.CLEAR_PREPARER_ASSIGNMENT: {
			if(action.payload){
				return { ...initialState.userAssignementInformation,
					userAssignementInformationSaved: action.payload.userAssignementInformationSaved
				} 
			}

			return initialState.userAssignementInformation;
			
		}
		default:
			return state;
	}
}
